export default "__VITE_ASSET__VztNSF_B__"